import {
    FETCH_BANK_STATEMENT_TRANSACTIONS,
    SAVE_BANK_STATEMENT_TRANSACTIONS
} from './actionTypes';


export const fetchBankStatementTransactions = (fileUpload) => ({
    type: FETCH_BANK_STATEMENT_TRANSACTIONS,
    payload: { fileUpload }
});


export const saveBankStatementTransactions = (transactions) => ({
    type: SAVE_BANK_STATEMENT_TRANSACTIONS,
    payload: { transactions }
})